export default "__VITE_ASSET__DjEQzRr1__"